import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';

const QUERY = gql`
  query GeneratePreview($landingPageAssetId: ID!, $htmlText: String!) {
    generatePreview(
      landingPageAssetId: $landingPageAssetId
      htmlText: $htmlText
    ) {
      screenshotBase64
      screenshotId
      screenshotUrl
    }
  }
`;

export const queryCOGeneratePreview = (
  { landingPageAssetId, htmlText },
  options
) => {
  const queryOptions = {
    query: QUERY,
    variables: {
      landingPageAssetId,
      htmlText,
    },
    fetchPolicy: 'no-cache',
  };

  if (options && options.abortSignal) {
    queryOptions.context = {
      fetchOptions: {
        signal: options.abortSignal,
      },
    };
  }

  return apolloClient
    .query(queryOptions)
    .then(({ data }) => getSingleProp(data));
};
